import * as ValidationRule from "../../utils/ValidationRule";
import * as yup from "yup";
import * as Yup from "yup";

class AgentPerson {
    constructor(jsonResponse) {
        this.firstName = jsonResponse["firstName"];
        this.lastName = jsonResponse["lastName"];
        this.dateOfBirth = jsonResponse["dateOfBirth"];
        this.title = jsonResponse["title"];
        this.gender = jsonResponse["gender"];
    }

}

class AgentAddress {
    constructor(jsonResponse) {
        this.streetNumber = jsonResponse["streetNumber"];
        this.streetName = jsonResponse["streetName"];
        this.suburb = jsonResponse["suburb"];
        this.city = jsonResponse["city"];
        this.province = jsonResponse["province"];
        this.postalCode = jsonResponse["postalCode"];
    }

}

class AgentContacts {
    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.contactType = jsonResponse["contactType"];
        this.contactName = jsonResponse["contactName"]
        this.contactValue = jsonResponse["contactValue"];
        this.primary = jsonResponse["primary"];
    }

}

class AgentIdentity {
    constructor(jsonResponse) {
        this.idType = jsonResponse["idType"];
        this.idNumber = jsonResponse["idNumber"];
        this.idExpiryDate = jsonResponse["idExpiryDate"];
        this.idIssuingCountry = jsonResponse["idIssuingCountry"];
        this.nationality = jsonResponse["nationality"];
        this.originCountry = jsonResponse["originCountry"];

    }

}

class AgentTraining {
    constructor(jsonResponse) {
        this.trainingDate = jsonResponse["trainingDate"];
        this.trainingMark = jsonResponse["trainingMark"];
        this.trainingPlatform = jsonResponse["trainingPlatform"];

    }
}


class AgentDocuments {
    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.documentType = jsonResponse["documentType"];
        this.metaDataId = jsonResponse["metaDataId"];
    }

}


export default class AgentCreateResponse {

    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.dateCreated = jsonResponse["dateCreated"];
        this.dateUpdated = jsonResponse["dateUpdated"];
        this.externalAgentIdentifier = jsonResponse["externalAgentIdentifier"];
        this.agentCode = jsonResponse["agentCode"];
        this.organisationId = jsonResponse["organisationId"];
        this.creatingUserId = jsonResponse["creatingUserId"];
        this.status = jsonResponse["status"];
        this.agentType = jsonResponse["agentType"];
        this.person = new AgentPerson(jsonResponse["person"]);
        this.address = new AgentAddress(jsonResponse["address"]);
        this.contacts = jsonResponse["contacts"].map((contact) => new AgentContacts(contact));
        this.identity = new AgentIdentity(jsonResponse["identity"]);
        if (jsonResponse["training"] === null) {
            this.training = null
        } else {
            this.training = new AgentTraining(jsonResponse["training"]);
        }

        this.documents = jsonResponse["documents"].map((document) => new AgentDocuments(document));

        this.manager = jsonResponse["manager"];
    }


    static retrieveNewAgentValidationConfig() {

        let validationRules = {
            title: Yup.string().required("Title is required"),
            firstName: ValidationRule.getAlphaSpaceValidator("First Name", true),
            lastName: ValidationRule.getAlphaSpaceValidator("Last Name", true),
            gender: Yup.string().required("Gender is required"),
            dateOfBirth: ValidationRule.getDOBValidator("Date of Birth", true),

            phoneNumber: ValidationRule.getCellphoneNumberRule("Phone number", true),
            alternativePhoneNumber: ValidationRule.getCellphoneNumberRule("Phone number", false),
            email: ValidationRule.getEmailAddressRule("Email Address", false),


            idType: ValidationRule.getStringRule("Id Type", true),
            idNumber: ValidationRule.getStringRule("Id Number", true) &&  Yup.string().matches(/^\S*$/, 'No spaces are allowed'),
            idExpiryDate: ValidationRule.getIdExpiryDateValidator("Id expiry date", true),
            idIssuingCountry: Yup.string().required("ID Issuing Country is required"),
            nationality: Yup.string().required("Nationality is required"),


            streetNumber: ValidationRule.getStringRule("Street Number", true),
            streetName: ValidationRule.getStringRule("Street Name", true),
            suburb: ValidationRule.getStringRule("Suburb", true),
            city: ValidationRule.getStringRule("City", true),
            province: ValidationRule.getStringRule("Province", true),
            postalCode: ValidationRule.getPostalCodeRule("Postal Code", true),

        };

        this.schema = {};
        Object.keys(validationRules).forEach(key => {
            let shapeWrapper = {
                [key]: validationRules[key]
            };

            this.schema[key] = yup.object().shape(shapeWrapper);
        });

        return this.schema;

    }
    static retrieveSAIDValidationConfig() {
        return yup.object().shape({
            idNumber: ValidationRule.getSAIDNumberValidatorBeforeDobGender("Id Number", true)
        });
    }

    static retrieveNonSAIDValidationConfig() {
        return yup.object().shape({
            idNumber: ValidationRule.getStringRule("Id Number", true) && Yup.string().matches(/^\S*$/, 'No spaces are allowed')
        });
    }





}
